/* eslint-disable import/prefer-default-export */
import { gql } from 'graphql-request';

export const listInvoiceGroupsGql = gql`
  query listInvoiceGroups {
    listInvoiceGroups {
      count
      results {
        invoiceGroupId
        invoiceGroupName
        isActive
        billTo {
          firstName
          lastName
          phone
          email
          streetAddress
          streetAddress2
          city
          state
          zip
        }
      }
    }
  }
`;

export const listInvoicesGql = gql`
  query listInvoices($filter: InvoiceFilter!, $sort: InvoiceSort, $limit: Int, $offset: Int) {
    listInvoices(filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
      count
      results {
        invoiceId
        invoiceDate
        invoiceStatus
      }
    }
  }
`;

export const getInvoiceDetailsGql = gql`
  query getInvoiceDetails($invoiceId: Int!) {
    getInvoiceDetails(invoiceId: $invoiceId) {
      invoiceUrl
      billTo {
        firstName
        lastName
        phone
        email
        streetAddress
        streetAddress2
        city
        state
        zip
      }
      invoiceData {
        invoiceDate
        dueDate
        subtotal
        tax
        invoiceTotal
      }
      invoiceLineItems {
        lineNumber
        ndc
        drugName
        description
        quantity
        unitCost
        lineTotal
      }
      customerMessage
    }
  }
`;

export const voidInvoiceGql = gql`
  mutation voidInvoice($invoiceId: Int!) {
    voidInvoice(invoiceId: $invoiceId) {
      invoiceId
      invoiceStatus
    }
  }
`;

export const markInvoicePaidGql = gql`
  mutation markInvoicePaid($invoiceId: Int!, $paidDate: String!, $reason: String!) {
    markInvoicePaid(invoiceId: $invoiceId, paidDate: $paidDate, reason: $reason) {
      invoiceId
      invoiceStatus
      reason
      paidDate
    }
  }
`;

export const editInvoiceGql = gql`
  mutation editInvoice(
    $invoiceId: Int!
    $invoiceLineItems: [InvoiceLineItemInput!]!
    $customerMessage: String
  ) {
    editInvoice(
      invoiceId: $invoiceId
      invoiceLineItems: $invoiceLineItems
      customerMessage: $customerMessage
    ) {
      invoiceId
    }
  }
`;

export const createInvoiceGql = gql`
  mutation createInvoice($input: CreateInvoiceInput!) {
    createInvoice(input: $input) {
      invoiceId
      invoiceStatus
    }
  }
`;

export const updateInvoiceGroupBillToGql = gql`
  mutation updateInvoiceGroupBillTo($invoiceGroupId: UUID!, $billTo: InvoiceBillToInput!) {
    updateInvoiceGroupBillTo(invoiceGroupId: $invoiceGroupId, billTo: $billTo) {
      invoiceGroupId
      invoiceGroupName
      isActive
      billTo {
        firstName
        lastName
        phone
        email
        streetAddress
        streetAddress2
        city
        state
        zip
      }
    }
  }
`;
